import { useContext } from "react";
import { JointBillContext } from "@features/JointBillList/utils";
import { Skeleton } from "@components/Skeleton/Skeleton";

export const FooterTotalCellSkeleton: React.FC = () => {
  const { isSummaryMode } = useContext(JointBillContext);

  return (
    <div className="flex items-center gap-4">
      <Skeleton className="w-28 text-lg" />
      {!isSummaryMode && (
        <div>
          <Skeleton className="h-5 w-5" />
        </div>
      )}
    </div>
  );
};
